module.exports = __webpack_public_path__ + "img/quadro-jovens.382743aa.svg";